import { Dialog, Toast } from "antd-mobile";
import axios from "axios";
import React, { useContext, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import PsContext from "../../context";
import { integerAadhar, momentDate, upperCase } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";

const StepThree = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() == false) {
      e.stopPropagation();
      setValidated(true);
      Toast.show({ content: "Please fill all the required fields" });
      return;
    }
    Dialog.confirm({
      content: "Do you want to update?",
      confirmText: "Yes",
      cancelText: "No",
      onConfirm: async () => {
        updateProfilee(form);
      },
    });
  };

  const updateProfilee = (form) => {
    context.setLoader(true);
    axios
      .post(ServiceUrl.STUDENTS.UPDATE_PROFILE_STEP_THREE, new FormData(form))
      .then((res) => {
        if (res["data"].status == "1") {
          if (props.onSuccess) props.onSuccess();
          Toast.show({
            content: res["data"].message || "Updated",
            icon: "success",
          });
          context.setStorage("setp_three", "yes");
        } else {
          Toast.show({ content: res["data"].message || "Error" });
        }
        context.setLoader(false);
      });
  };

  const maxDate = () => {
    let y = momentDate(new Date(), "YYYY") - 16;
    let d = momentDate(new Date(), "DD");
    let m = momentDate(new Date(), "MM");
    return momentDate(y + "-" + m + "-" + d, "YYYY-MM-DD");
  };

  const studentData = (fieldName) => {
    let d = context.getStorage("update_stu_data");
    if (d) d = JSON.parse(d);
    return d?.[fieldName];
  };
  console.log(props);
  const field = (fieldName) => {
    let m = props.dataSource;
    return m?.[fieldName];
  };

  return (
    <>
      <Form
        action=""
        method="post"
        noValidate
        validated={validated}
        onSubmit={handleFormSubmit}
      >
        <input type="hidden" name="uuid" value={studentData("uuid")} />
        <input
          type="hidden"
          name="registerno"
          value={studentData("registerno")}
        />

        <div className="bg-blue-100 text-primary fw-bold p-2 form-title-card">
          Certificate Details
        </div>
        <div className="container py-2">
          <Row className="">
            <Col md={4} sm={4} xs={4}>
              <label>
                Aadhar No <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="number"
                size="sm"
                className="fw-bold"
                name="aadharno"
                onKeyPress={integerAadhar}
                defaultValue={field("aadharno")}
                required
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Voter Id No <span className="text-danger"></span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="voteridno"
                defaultValue={field("voteridno")}
              />
            </Col>
          </Row>

          {upperCase(field("community_name")) != "OC" && (
            <Row className="mt-2">
              <Col md={4} sm={4} xs={4}>
                <label>
                  Community Certificate No{" "}
                  <span className="text-danger">*</span>
                </label>
              </Col>
              <Col md={8} sm={8} xs={8}>
                <Form.Control
                  type="text"
                  size="sm"
                  className="fw-bold"
                  name="community_certificate_no"
                  defaultValue={field("community_certificate_no")}
                  required
                />
              </Col>
            </Row>
          )}

          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                HSC Reg.No <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="plus2registerno"
                defaultValue={field("plus2registerno")}
                required
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Type <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                as="select"
                size="sm"
                className="fw-bold"
                name="stuent_type"
                required
              >
                <option value="">-Select-</option>
                <option
                  value="hosteller"
                  selected={field("is_hosteller") == "1" ? "selected" : ""}
                >
                  Hosteller
                </option>
                <option
                  value="daysschollar"
                  selected={field("is_days_schollar") == "1" ? "selected" : ""}
                >
                  Days Schollar
                </option>
              </Form.Control>
            </Col>
          </Row>
        </div>

        <div className="bg-blue-100 text-primary fw-bold p-2 form-title-card">
          Bank Details
        </div>
        <div className="container py-2">
          <Row className="">
            <Col md={4} sm={4} xs={4}>
              <label>
                Bank Name <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="bank_name"
                defaultValue={field("bank_name")}
                required
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Branch Name <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="branch_name"
                defaultValue={field("branch_name")}
                required
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Account No <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="bank_account_no"
                defaultValue={field("bank_account_no")}
                required
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                IFSC Code <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="bank_ifsc_code"
                defaultValue={field("bank_ifsc_code")}
                required
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                MICR Code <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="bank_micr_no"
                defaultValue={field("bank_micr_no")}
                required
              />
            </Col>
          </Row>
        </div>

        <div className="container py-3">
          <Row>
            <Col md={12}>
              <Button
                type="submit"
                variant="warning"
                className="w-100"
                size="lg"
              >
                Save & Continue
              </Button>
            </Col>
          </Row>
        </div>
      </Form>
    </>
  );
};
export default StepThree;
